export const mutations = {
  set_token(state, token) {
    state.token = token;
    sessionStorage['site_current_token'] = token;
  },
  set_userid(state, userid) {
    state.userid = userid;
    localStorage['site_current_userid'] = userid;
  },
  set_appid(state, appid) {
    state.app_id = appid
    localStorage['site_current_app_id'] = appid;
  },
  retry_count_add(state) {
    state.retry_count++;
  },
  set_login_go(state, path) {
    state.after_login_go = path;
    localStorage['site_current_login_go'] = path;
  },
  set_nickname(state,nickname){
    state.wx_info.nickname = nickname;
    localStorage['wx_nickname'] = nickname;
  },
  set_headimgurl(state,headimgurl)
  {
    state.wx_info.headimgurl = headimgurl;
    localStorage['wx_headimgurl'] = headimgurl;
  },
  set_openid(state,openid)
  {
    state.wx_info.openid = openid;
    localStorage['wx_openid'] = openid;
  },
  set_username(state,username)
  {
    state.wx_info.username = username;
    localStorage['wx_username'] = username;
  },
  set_mobile(state,mobile)
  {
    state.wx_info.mobile = mobile;
    localStorage['wx_mobile'] = mobile;
  },
  set_vehicleState(state,vehicleState)
  {
    state.vehicleState = vehicleState;
    localStorage['vehicleState'] = vehicleState;
  }

}
